<template>
  <b-modal hide-footer id="techSupportModal" title="Техническая поддержка" @hidden="onReset"
           ref="modalTechSupport" header-bg-variant="primary"
           header-text-variant="light">
    <b-form @submit="onSubmit" @reset="onReset">
      <b-form-group
        label="Почта"
        label-for="emailForSupportInput"
        description="На эту почту придёт ответ от администратора."
      >
        <b-form-input
          id="emailForSupportInput"
          v-model="form.email"
          type="email"
          required
          placeholder="Введите почту"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Фамилия" label-for="surnameForSupportInput">
        <b-form-input
          id="surnameForSupportInput"
          v-model="form.surname"
          required
          placeholder="Введите фамилию"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Имя" label-for="nameForSupportInput">
        <b-form-input
          id="nameForSupportInput"
          v-model="form.name"
          required
          placeholder="Введите имя"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Сообщение" label-for="textForSupportInput">
        <b-form-textarea
          id="textForSupportInput"
          v-model="form.text"
          required
          placeholder="Введите Ваше сообщение"
          rows="3"
          no-resize
        ></b-form-textarea>
      </b-form-group>
      <b-button type="submit" variant="primary" style="width:49%; margin-right: 2%">Отправить</b-button>
      <b-button type="reset" variant="outline-primary" style="width:49%">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TechSupportFormModal',
  data() {
    return {
      form: {
        email: '',
        name: '',
        surname: '',
        text: ''
      }
    }
  },
  methods: {
    ...mapActions({
      techSupportRequest: 'chats/techSupportRequest',
      pushToasts: 'toasts/pushToasts'
    }),
    onSubmit(evt) {
      evt.preventDefault()
      if (!(/[а-яА-ЯеЁ]+/.test(this.form.text)) || this.form.text.length < 7) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Пожалуйста, подробнее опишите ситуацию на русском языке.'
          })
          return
      }
      this.techSupportRequest(this.form).then((resp) => {
        if (resp && resp.status && resp.status !== 204) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'При отправке сообщения в тех. поддержку произошла ошибка. Сообщение не было доставлено.'
          })
        }
        else {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Сообщение успешно доставлено в тех. поддержку. Администратор свяжется с Вами по почте, указанной Вами в форме.'
          })
        }
      })
      this.$nextTick(() => {
        this.$refs.modalTechSupport.hide()
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.surname = ''
      this.form.text = ''
      this.$refs.modalTechSupport.hide()
    }
  }
}
</script>

<style scoped>

</style>
